import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { vendorFields } from '../../data/vendorFields';

// Specify the required order for categories using the exact keys from vendorFields
const orderedCategories = [
  // 'Hospital',
  'Doctor Clinic',
  // 'Medical Store',
  'Ambulance Agency',
  // 'Blood Bank Agency',
  // 'Diagnostic Center',
  // 'Product Partner',
];

const categoryDisplayNames: Record<string, string> = {
  'Hospital': 'Hospital',
  'Doctor Clinic': 'Clinic',
  'Medical Store': 'Medical Store',
  'Ambulance Agency': 'Ambulance Agency',
  'Blood Bank Agency': 'Blood Bank',
  'Diagnostic Center': 'Diagnostic Center',
  'Product Partner': 'Product Partner',
};

const SalesExecutiveAddVendorPage: React.FC = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState<{ [key: string]: string }>({ category: '' });
  const [categorySelected, setCategorySelected] = useState(false);

  const handleCategoryBoxClick = (cat: string) => {
    if (cat === 'Hospital') {
      navigate('/sales/vendor-onboarding/add/hospital');
      return;
    }
    if (cat === 'Ambulance Agency') {
      navigate('/sales/vendor-onboarding/add/ambulance');
      return;
    }
    if (cat === 'Doctor Clinic') {
      navigate('/sales/vendor-onboarding/add/clinic');
      return;
    }
    if (cat === 'Medical Store') {
      navigate('/sales/vendor-onboarding/add/medical-store');
      return;
    }
    if (cat === 'Blood Bank Agency') {
      navigate('/sales/vendor-onboarding/add/blood-bank');
      return;
    }
    if (cat === 'Diagnostic Center') {
      navigate('/sales/vendor-onboarding/add/diagnostic-center');
      return;
    }
    if (cat === 'Product Partner') {
      navigate('/sales/vendor-onboarding/add/product-partner');
      return;
    }
    setForm({ category: cat });
    setCategorySelected(true);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert('Vendor added! (Functionality coming soon)');
    navigate(-1);
  };

  const fields = form.category ? vendorFields[form.category] : [];

  return (
    <div className="max-w-xl mx-auto mt-8 bg-white dark:bg-gray-800 rounded-xl shadow-lg p-8">
      <button
        onClick={() => navigate(-1)}
        className="mb-6 text-primary-600 dark:text-primary-400 hover:underline text-sm"
      >
        &larr; Back to Vendor List
      </button>
      <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">Onboard a New Vendor</h2>
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">Select Vendor Type</label>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
          {orderedCategories.map((cat) => (
            <button
              type="button"
              key={cat}
              onClick={() => handleCategoryBoxClick(cat)}
              className={`flex items-center justify-center rounded-xl border-2 transition-all shadow-sm px-4 py-6 font-semibold text-lg cursor-pointer focus:outline-none
                ${form.category === cat
                  ? 'border-primary-600 bg-primary-50 dark:bg-primary-900/30 text-primary-700 dark:text-primary-300 shadow-lg scale-105'
                  : 'border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-700 text-gray-700 dark:text-gray-200 hover:border-primary-400 hover:bg-primary-50/50 dark:hover:bg-primary-900/10'}
              `}
            >
              {categoryDisplayNames[cat]}
            </button>
          ))}
        </div>
      </div>
      {form.category && (
        <form className="space-y-5" onSubmit={handleSubmit}>
          {fields.map((field) => (
            <div key={field.name}>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">{field.label}</label>
              <input
                type="text"
                name={field.name}
                value={form[field.name] || ''}
                onChange={handleChange}
                required
                className="mt-1 block w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-800 dark:text-white shadow-sm focus:ring-2 focus:ring-primary-500 focus:border-primary-500 px-4 py-2"
                placeholder={`Enter ${field.label.toLowerCase()}`}
              />
            </div>
          ))}
          <button
            type="submit"
            className="w-full py-2 px-4 bg-gradient-to-r from-primary-600 to-primary-500 hover:from-primary-700 hover:to-primary-600 text-white rounded-lg font-semibold shadow-md transition-all text-base tracking-wide mt-2"
          >
            Add Vendor
          </button>
        </form>
      )}
    </div>
  );
};

export default SalesExecutiveAddVendorPage; 